export default "__VITE_ASSET__B$zs0fFW__"